import React from 'react';
import { Navigate } from 'react-router-dom';
import ROUTES from './../../constants/routes';
import FormValidator from './../login/FormValidator';
import './../../css/CIDChallenge.css';
import securitycodenumbers from './../../images/security-code-numbers.png';
import discoveritEmvbackCopy from './../../images/discoverit-it-emv-back-copy.png';
import alert from './../../images/alert.png';
import Modal from './Modal';
import spinner from './../../Spinnerimage.gif';
import {HttpStatusCode, ResultCodes, Messages} from './../../constants/utilities';
import {connect} from 'react-redux';
import AxiosDataService from '../../services/AxiosDataService';
import {OnCIDChallengePageLoad,OnLinkingSuccess,OnCIDCancel} from './../../components/SiteCat/SiteCat'
import {onUserCancel} from './../../constants/merchantData';


class NoContactChannel extends React.Component{
  constructor(props, context) {
    super(props, context);
    let cardnumber;

    const linkidresponseCardNum = this.props.cidposts.selectedCarddigits;
    if(this.props.location.carddata) {
      cardnumber = this.props.location.carddata.carddigits;
    }else if(linkidresponseCardNum){
      cardnumber = linkidresponseCardNum;
    }else{
      cardnumber = 'xxxx';
    }
    this.validator = new FormValidator([
      {
        field: 'securityCode',
        method: 'isEmpty',
        validWhen: false,
        message: Messages.ENTER_VALID_CVV_CODE
      },
      {
        field: 'expiryDate',
        method: 'isEmpty',
        validWhen: false,
        message: Messages.ENTER_VALID_EXPIRY_DATE
      }

    ]);

    this.state = {
      securityCode: "",
      expiryDate: "",
      validation: this.validator.valid(),
      submitted: false,
      showError:false,
      errMsgSecuriyCode: "",
      CIDCancel: false,
      linkId: "",
      errMessageCVV: "",
      show: false,
      errMsg: "",
      slashflag: false,
      cardnumber: cardnumber,
      merchantName:""
    }

  };
  componentDidMount(){
    OnCIDChallengePageLoad();

    const jwtTokenData = this.props.cidposts.jwtToken.jwtToken    
    const linkidresponse = this.props.cidposts.loginresponse.linkId
    const cancelUrl = this.props.cidposts.cancelUrl
    this.setState({
      merchantName : this.props.cidposts.merchant,
      linkId: linkidresponse,
      jwtTokenData,
      cancelUrl
      
     
    });
    const pasteBox = document.getElementById("no-paste");
    const pasteBoxCvv = document.getElementById("no-paste-cvv");
    pasteBox.onpaste = e => {
      e.preventDefault();
      return false;
    };
    pasteBoxCvv.onpaste = e => {
      e.preventDefault();
      return false;
    };
  }
  handleFormSubmit = event => {

    const validation = this.validator.validate(this.state)
    this.setState({
      validation,
      submitted: true,
      showError: false
    });
    if (validation.securityCode.message === "" && validation.expiryDate.message === "") {
      const valdiatedate = this.validateDateField(this.state.expiryDate)
      const valdiateCVV = (/^[0-9]{1,3}$/.test(this.state.securityCode))
      const inputValidCvv = this.state.securityCode
      const valdiateCVVLength = inputValidCvv.length
      if(valdiateCVVLength <3 || !valdiatedate || !valdiateCVV){
        let errDateMessage, errCvvMessage
        if((!valdiatedate) && (!valdiateCVV || valdiateCVVLength < 3) ){
            errDateMessage = Messages.ENTER_VALID_EXPIRY_DATE
            errCvvMessage = Messages.ENTER_VALID_CVV_CODE
        }else if(!valdiatedate){
          errDateMessage = Messages.ENTER_VALID_EXPIRY_DATE
          errCvvMessage = ""
        }else if (!valdiateCVV || valdiateCVVLength < 3){
          errDateMessage = ""
          errCvvMessage = Messages.ENTER_VALID_CVV_CODE
        }
        window.scrollTo(0, 0);
        this.setState({
          showError: true,
          errMsg: errDateMessage,
          errMessageCVV: errCvvMessage,
          isLoaded: false
        });
       
      }else{
       // return false
        this.setState({ isLoaded: true });
        this.setState({ CIDCancel: false });
        const actExpDate = this.state.expiryDate
        const modifiedExpDate =  actExpDate.replace("/", "");

        let userData = {
          "cidCancel": false,
          "cidInfo": {
            "cvvCode": this.state.securityCode,
            "expDate": modifiedExpDate
          },
          "linkId": this.state.linkId,
          "merchantName": this.state.merchantName
    
        }
         
       let randomstring = require('random-string');
       const self = this;
       const options = {
         url: "cid/validateCid",    // + Config.env,
         method: "post",
         headers: {
           "Access-Control-Allow-Origin": "*",
           //"HTTP_AUTH_TOKEN": self.state.jwtTokenData,
           'Content-Type': 'application/json',
           "REQUEST_ID": randomstring({ length: 20 })
         },
         data: JSON.stringify(userData)
        };
        AxiosDataService.fetch(options).then((responsedata) => {
           self.setState({ isLoaded: false });
         let response=responsedata.data;
         
           if (response.resultCode === ResultCodes.MERCHANT_REDIRECT_PAGE) {
            OnLinkingSuccess(this.state.merchantName);
             const redirecturl = response.partnerRedirectVO.href
             self.setState({
               pageName: "RedirectPage",
               doRedirect: true,
               locationhref: redirecturl
             });
           } else if (response.resultCode === ResultCodes.CONTACT_SELECTION_PAGE) {
                
            /*
            self.props.dispatch({
                  type:'LOGIN_RESPONSE',
                  linkId: response.linkId,
                   response
                  });
                self.setState({ pageName: "SingleCardPage" });
                self.setState({ doRedirect: true });
                */
                self.props.dispatch({
                    type:'LINKFI_RESPONSE',
                    response,
                    selectedCarddigits: responsedata.data,
                    last4Digit:this.props.cidposts.loginresponse.last4AcctNbr ? this.props.cidposts.loginresponse.last4AcctNbr : ( typeof this.props.cidposts.selectedCarddigits == "object" ? "xxxx" : this.props.cidposts.selectedCarddigits)//************
                    
                });
                self.setState({ pageName: "ContactChannels" });
                self.setState({ doRedirect: true });
          } else if (response.resultCode === ResultCodes.INVALID_EXP_DATE) {
            window.scrollTo(0, 0);
             self.setState({
               showError: true,
               doRedirect: false,
               errMessageCVV: Messages.ENTER_VALID_CVV_CODE,
               errMsg: Messages.ENTER_VALID_EXPIRY_DATE
             });
           }else if (response.resultCode === ResultCodes.CARD_MEMBER_LOCKOUT) {
            self.setState({
              pageName: "CIDLockOutPage",
              doRedirect: true
            });
          }
         else if (response.resultCode === ResultCodes.CARD_INFO_DELIVERY_FAILED) {
            self.setState({
              pageName: "TechDiff",
              doRedirect: true
            });
          }
          else if (response.resultCode === ResultCodes.ACCT_LINKING_PAGE) {
                
                self.props.dispatch({
                  type:'LOGIN_RESPONSE',
                  linkId: response.linkId,
                   response,
                   last4Digit:this.props.cidposts.loginresponse.last4AcctNbr
                  });
              let AccLinkingResponse = response.eligibleAccountVO;
              if (AccLinkingResponse.length === 1) {
                self.setState({ pageName: "SingleCardPage" });
                self.setState({ doRedirect: true });
              } else if (AccLinkingResponse.length > 1) {
                self.setState({ pageName: "MultiCardPage" });
                self.setState({ doRedirect: true });
              } else {
                self.setState({ pageName: "TryLinkingAgainPage" });
                self.setState({ doRedirect: true });
              }
              
          }
           else {
            self.setState({
              pageName: "TechDiff",
              doRedirect: true
            });
           }
         },(errorResponse) => {
           self.setState({ isLoaded: false });
           let error = errorResponse.response;
           if (error.status === HttpStatusCode.INTERNAL_SERVER_ERROR || error.status === HttpStatusCode.NOT_FOUND4) {
            
             self.setState({
               pageName: "TechDiff",
               doRedirect: true
             });
           } else {
 

             let response = error.data;
             if (response) {
               if (error.status === HttpStatusCode.BAD_REQUEST && response.returnCode === ResultCodes.MANDATORY_FIELD) {
                window.scrollTo(0, 0);
                self.setState({
                  showError: true,
                  doRedirect: false,
                  errMessageCVV: Messages.ENTER_VALID_CVV_CODE,
                  errMsg: Messages.ENTER_VALID_EXPIRY_DATE
                });
               } else if (response.returnCode === ResultCodes.TECH_DIFF_RA_DOWN || response.returnCode === ResultCodes.TECH_DIFF_DPL_DOWN || response.returnCode === ResultCodes.TECH_DIFF_CACHE_DOWN || response.returnCode === ResultCodes.TECH_DIFF_NO_LINK_ACTIVITY) {
                 self.setState({
                   pageName: "TechDiff",
                   doRedirect: true
                 });
               } else {
                 self.setState({
                   pageName: "TechDiff",
                   doRedirect: true
                 });
               }

             } else {
               self.setState({
                 pageName: "TechDiff",
                 doRedirect: true
               });
             }
            }
       })
       
      }
 

    } else {
      window.scrollTo(0, 0);
     this.setState({
        showError: true,
        errMsg: "",
        isLoaded: false
      });

      

    }
}

char_count(str, letter) {
 var letter_Count = 0;
 for (var position = 0; position < str.length; position++) {
    if (str.charAt(position) === letter) {
      letter_Count += 1;
    }
  }
  return letter_Count;
}

textposition() {
    var ctl = document.getElementById('no-paste');
    var startPos = ctl.selectionStart;
    //var endPos = ctl.selectionEnd;
    //alert(startPos + ", " + endPos);
    return startPos;
}


handleInputChange = event => {
  event.preventDefault();
  

  if(event.target.name === "securityCode"){
    if(event.target.value.length > 3) {
      return false;
     }
    const acceptedSecurityCode = (/^[0-9]{1,3}$/.test(+event.target.value)) ? event.target.value : this.state.securityCode;
    
    const inputValidCvv = acceptedSecurityCode
    const valdiateCVVLength = inputValidCvv.length
     if(this.state.submitted){
      if(valdiateCVVLength < 3){
        this.setState({
          showError: true,
          errMessageCVV: Messages.ENTER_VALID_CVV_CODE,
          isLoaded: false
        });
      }else{
        this.setState({
          showError: false,
          errMessageCVV: "",
          isLoaded: false
        });
      }
  }
    this.setState({
      [event.target.name]: acceptedSecurityCode 
    })
  }else if(event.target.name === "expiryDate" && /^[0-9\/]*$/.test(event.target.value)){
    
    if(event.target.value.includes("/")){
      const getTwodigit = event.target.value.split("/")[1].length;
      const getOnedigit = event.target.value.split("/")[0].length;
      if(getTwodigit > 2){
      return false;
      }
      if(getOnedigit > 2){
        return false;
        }
      if(event.target.value.length === 1 && !this.state.expiryDate.includes("/")){
        return false;
      }
    }
    const getTtldigit = event.target.value.length;
    if(this.textposition() === 3 && getTtldigit === 5 && !event.target.value.includes("/")) {
        return false;
    }
    if((this.textposition() === 1 || this.textposition() === 2 || this.textposition() === 4 || this.textposition() === 5) && getTtldigit === 5 && !this.state.expiryDate.includes("/")) {
      return false;
  }

    let acceptedExpDate = event.target.value;
    let inputExyDatLen = acceptedExpDate.length;
    if(inputExyDatLen < 4 && !event.target.value.includes("/")) {
      this.setState({
        slashflag: false
      });
    }
    if(inputExyDatLen < 6 ) {
      if(inputExyDatLen < 3 && acceptedExpDate.includes("/")){
        let acceptedExpDateVal = this.state.expiryDate;
        const getfulldigitdata = event.target.value.length;
        const getTwodigitdata = event.target.value.split("/")[1].length;
        const getOnedigitdata = event.target.value.split("/")[0].length;
        if(getfulldigitdata === 2 && acceptedExpDateVal.includes("/")){
          this.setState({
            [event.target.name]: event.target.value
          })
        }else if(getOnedigitdata === 1 && getTwodigitdata === 0){
          this.setState({
            [event.target.name]: acceptedExpDateVal
          })
        }else  if((getOnedigitdata === 0) && acceptedExpDate.includes("/")){
          this.setState({
            [event.target.name]: event.target.value
          })
        }else if(getOnedigitdata === 1){
          this.setState({
            [event.target.name]: acceptedExpDateVal
          })
        }else if(getTwodigitdata < 2 && (getOnedigitdata === 0 || getOnedigitdata === 1)){
          this.setState({
            [event.target.name]: acceptedExpDateVal
          })
        }else{
          this.setState({
            [event.target.name]: acceptedExpDateVal
          })
        }

      }else if(inputExyDatLen===3) {
        //let lastChar1 = acceptedExpDate[acceptedExpDate.length -1];
        var newStr = event.target.value.substring(0, event.target.value.length - 1);
        //const getMonth  = event.target.value.slice(0, 2);
       // const lastChar = event.target.value[event.target.value.length -1];
        if(this.state.slashflag){
          //acceptedExpDate = event.target.value;
          if(event.target.value.includes("/")){
            acceptedExpDate = this.state.expiryDate;
            if(this.char_count(event.target.value, '/') > 1){
              this.setState({
                [event.target.name]: acceptedExpDate
              })
            }else{
              this.setState({
                [event.target.name]: event.target.value
              })
            }
            
          }else{
            this.setState({
              [event.target.name]: newStr,
              slashflag: false
            })
          }
        }else{
          const getMonth  = event.target.value.slice(0, 2);
          const lastChar = event.target.value[event.target.value.length -1];
          let formString;
          if(event.target.value.includes("/")){
            acceptedExpDate = this.state.expiryDate;
            if(this.char_count(event.target.value, '/') > 1){
              this.setState({
                [event.target.name]: acceptedExpDate
              })
            }else if(lastChar === '/'){
              formString = getMonth+"/";
          }else{
            formString = event.target.value;
          }
          }else{
            formString = getMonth+"/"+lastChar;
          }
          
        // acceptedExpDate = '/' + event.target.value;
          this.setState({
            [event.target.name]: formString,
            slashflag: true
          })
          
        }
      
        }else if(inputExyDatLen > 3) {
          let lastChar = acceptedExpDate[acceptedExpDate.length -1];
          acceptedExpDate = this.state.expiryDate;
            if(this.char_count(event.target.value, '/') > 1){
              this.setState({
                [event.target.name]: acceptedExpDate
              })
            }else if(lastChar === "/"){
              this.setState({
                [event.target.name]:  this.state.expiryDate
              });
            }else{
              this.setState({
                [event.target.name]:  event.target.value
              });
            }
      }else{
        acceptedExpDate = (/^[0-9\\/]*$/.test(event.target.value)) ? event.target.value : this.state.expiryDate;
        this.setState({
          [event.target.name]: acceptedExpDate
        });
      }
  }else{
    this.setState({
      [event.target.name]: this.state.expiryDate
    });
  }
    const valdiatedate = this.validateDateField(event.target.value);
    let errDateMessage, errCvvMessage, showErrorstate
    if(!valdiatedate && this.state.submitted) {
    //if(!valdiatedate && getTtldigit === 5 && this.state.submitted){
      errDateMessage = Messages.ENTER_VALID_EXPIRY_DATE
      showErrorstate = true
    }else {
      errDateMessage = ""
      showErrorstate = false
    }
    this.setState({
      showError: showErrorstate,
      errMsg: errDateMessage,
      isLoaded: false
    });
      return false
 
  }else {
    const acceptedExpDate =event.target.value
    if(acceptedExpDate === "") {
      this.setState({
        [event.target.name]: ""
      });
    }else {
      this.setState({
        [event.target.name]: this.state.expiryDate
      });
    }
  }
}

handleEvtCancel = event => {
  OnCIDCancel();
    this.setState({ isLoaded: true });
    this.setState({ CIDCancel: true });
    
    let userData = {
      "cidCancel": true,
      "cidInfo": {
        "cvvCode": this.state.securityCode,
        "expDate": this.state.expiryDate
      },
      "linkId": this.state.linkId,
      "merchantName": this.state.merchantName

    }
 
    let randomstring = require('random-string');
    const self = this;
    const options = {
      url: "cid/validateCid",
      method: "post",
      headers: {
        "Access-Control-Allow-Origin": "*",
        //"HTTP_AUTH_TOKEN": self.state.jwtTokenData,
        'Content-Type': 'application/json',
        "REQUEST_ID": randomstring({ length: 20 })
      },
      data: JSON.stringify(userData)
    };
    AxiosDataService.fetch(options).then((responsedata) => {
        self.setState({ isLoaded: false });
         let response=responsedata.data;
         
        if (response.resultCode === ResultCodes.ACCT_LINKING_PAGE|| response.resultCode === ResultCodes.INVALID_EXP_DATE|| response.resultCode === ResultCodes.CONTACT_SELECTION_PAGE) {
              let AccLinkingResponse = self.props.cidposts.loginresponse.eligibleAccountVO ? self.props.cidposts.loginresponse.eligibleAccountVO : response.eligibleAccountVO;
             
              if (AccLinkingResponse.length === 1) {
                self.setState({ pageName: "SingleCardPage" });
                self.setState({ doRedirect: true });
              } else if (AccLinkingResponse.length > 1) {
                self.setState({ pageName: "MultiCardPage" });
                self.setState({ doRedirect: true });
              } else {
                self.setState({ pageName: "TryLinkingAgainPage" });
                self.setState({ doRedirect: true });
              }
         
        } else if (response.resultCode === ResultCodes.REDIRECT_TO_MERCHANT) {
            let data = {
              merchantName: this.state.merchantName,
              cancelUrlData: this.state.cancelUrl
            }
            onUserCancel(data);

        }else if (response.resultCode === ResultCodes.CARD_MEMBER_LOCKOUT) {
          self.setState({
            pageName: "CIDLockOutPage",
            doRedirect: true
          });
        } else if (response.resultCode === ResultCodes.CARD_INFO_DELIVERY_FAILED) {
          self.setState({
            pageName: "TechDiff",
            doRedirect: true
          });
        }
        else {
          self.setState({ pageName: "TechDiff" });
          self.setState({ doRedirect: true });
        }
      },(errorResponse) => {
        self.setState({ isLoaded: false });
        let error = errorResponse.response;
        if (error.status === HttpStatusCode.INTERNAL_SERVER_ERROR || error.status === HttpStatusCode.NOT_FOUND) {
          self.setState({
            pageName: "TechDiff",
            doRedirect: true
          });
        } else {
 
         
          let response = error.data;
          if (response) {
            if (error.status === HttpStatusCode.BAD_REQUEST && response.returnCode === ResultCodes.MANDATORY_FIELD) {

                let AccLinkingResponse = self.props.cidposts.loginresponse.eligibleAccountVO;
                   // let AccLinkingResponse = self.props.cidposts.loginresponse.eligibleAccountVO;
                if (AccLinkingResponse.length === 1) {
                  self.setState({ pageName: "SingleCardPage" });
                  self.setState({ doRedirect: true });
                } else if (AccLinkingResponse.length > 1) {
                  self.setState({ pageName: "MultiCardPage" });
                  self.setState({ doRedirect: true });
                } else {
                  self.setState({ pageName: "TryLinkingAgainPage" });
                  self.setState({ doRedirect: true });
                }
            } else if (response.returnCode === ResultCodes.TECH_DIFF_RA_DOWN || response.returnCode === ResultCodes.TECH_DIFF_DPL_DOWN || response.returnCode === ResultCodes.TECH_DIFF_CACHE_DOWN || response.returnCode === ResultCodes.TECH_DIFF_NO_LINK_ACTIVITY) {
              self.setState({
                pageName: "TechDiff",
                doRedirect: true
              });
            } else {
              self.setState({
                pageName: "TechDiff",
                doRedirect: true
              });
            }

          } else {
            self.setState({
              pageName: "TechDiff",
              doRedirect: true
            });
          }
        }
    })
  }

  showModal = () => {
    this.setState({ show: true });
  };

  hideModal = () => {
    this.setState({ show: false });
  };

  
handleOnBlur = (event) => {
  event.preventDefault();
  if(this.state.submitted){
    this.setState({
      showError: false
    })
 
    
    const valdiatedate = this.validateDateField(this.state.expiryDate)
    
    
    const valdiateCVV = (/^[0-9]{1,3}$/.test(this.state.securityCode))
    
    const inputValidCvv = this.state.securityCode
    const valdiateCVVLength = inputValidCvv.length
   
    
    if(valdiateCVVLength <3 || !valdiatedate || !valdiateCVV){
      let errDateMessage, errCvvMessage, showErrorstate
      if((!valdiatedate) && (!valdiateCVV || valdiateCVVLength < 3) ){
          errDateMessage = Messages.ENTER_VALID_EXPIRY_DATE
          errCvvMessage = Messages.ENTER_VALID_CVV_CODE
          showErrorstate = true
      }else if(!valdiatedate && valdiateCVV && valdiateCVVLength === 3){
        
        errDateMessage = Messages.ENTER_VALID_EXPIRY_DATE
        errCvvMessage = ""
        showErrorstate = true
      }else if ((!valdiateCVV || valdiateCVVLength < 3) && valdiatedate){
        
        errDateMessage = ""
        errCvvMessage = Messages.ENTER_VALID_CVV_CODE
        showErrorstate = true
      }else{
        
        errDateMessage = ""
        errCvvMessage = ""
        showErrorstate = false
      }
      this.setState({
        showError: showErrorstate,
        errMsg: errDateMessage,
        errMessageCVV: errCvvMessage,
        isLoaded: false
      });
    }else{
      this.setState({
        showError: false,
        errMsg: "",
        errMessageCVV: "",
        isLoaded: false
      });
    }
}
}

validateDateField = (date) => {
  let fieldValue = date;
  if(fieldValue.length  === 5) {
    let enteredMonth = parseInt(fieldValue.split("/")[0]),
        enteredYear = parseInt(fieldValue.split("/")[1]),
        currentDate = new Date(),
        currentMonth = currentDate.getMonth() + 1,
        currentYear = parseInt(currentDate.getFullYear().toString().substring(2));
    if(enteredYear < currentYear) {
      
      return false
    }else if(enteredYear === currentYear){
      if((enteredMonth< 1) || (enteredMonth>12)  || (enteredMonth < currentMonth)){
       
          return false
      }else{
      
        
        return true
      }
      
    }else {

      if(enteredMonth< 1 || enteredMonth>12){
        
          return false
      }else{
      
        
        return true
      }

    }
  } else {
    
    return false
  }
}

  render() {


    if(this.state.doRedirect === true){
      //TODO: Need to change to validate OOB page for success
       if (this.state.pageName === "CIDLockOutPage"){
				return <Navigate to={ROUTES.PATH.CIDLockOutPage} replace />
			}else if (this.state.pageName === "LockedOutPage"){
				return <Navigate to={ROUTES.PATH.LockedOutPage} replace />
      } else if (this.state.pageName === "SingleCardPage") {
          return <Navigate to={ROUTES.PATH.SingleCardPage} replace />
        } else if (this.state.pageName === "MultiCardPage") {
          return <Navigate to={ROUTES.PATH.MultiCardPage} replace />
        }else if (this.state.pageName === "ContactChannels") {
          return <Navigate to={ROUTES.PATH.ContactChannels} replace />
        }else if (this.state.pageName === "TechDiff") {
          return <Navigate to={ROUTES.PATH.TechDiff} replace />
        }else if (this.state.pageName === "RedirectPage") {
          return (
            <Navigate to={{pathname: ROUTES.PATH.RedirectPage}}
              state={{ loc: this.state.locationhref }}
              replace
            />
          );
        }
        else{
          return <Navigate to={ROUTES.PATH.TryLinkingAgainPage} replace />
        }
    }else {
    let validation = this.state.submitted ?
      this.validator.validate(this.state) :
      this.state.validation
      let isLoadervalue = this.state.isLoaded;
      
      
     
    return(
       
        <div className="row">
        {isLoadervalue ?
               <div className="spinner">
               <img src={spinner} alt="Spinner"/>
             </div> : null
          }

          <div className="cid-header-logo col-xs-12 col-md-7 col-lg-5 .col-xl-5">
             { (validation.securityCode.message !=="" || validation.expiryDate.message !=="" || this.state.errMessageCVV!=="" || this.state.errMsg!=="") ?
                <div className="row cid-banner">
                  <div className="col-xs-2 col-sm-2  col-md-2 col-lg-2 banner-img"> <img src={alert} class="Alert" alt="Alert"/></div>
                  <div class="col-xs-10 col-sm-10  col-md-10 col-lg-10 security-code-banner">
                      <div className="header">Error Message</div>
                      <div className="subheader">Please enter the following selections to verify your information:</div>
                        <ul>{(validation.securityCode.message !=="" || this.state.errMessageCVV!=="") ? <li  onClick={() => {this.myInp.focus()}}>Security Code</li> : false}{(validation.expiryDate.message !=="" || this.state.errMsg!=="") ? <li onClick={() => {this.myInp2.focus()}}>Expiration Date</li> : false}
                        </ul>
                      </div>
                </div> : 
                null 
              }
            <div className="CID-account-confirmation">Account Confirmation</div>
            <div className="confirm-your-account">Confirm your account details to help you stay secure.</div>
            <hr className="account-confirm-line" ></hr>
            <div className="Please-enter-Securit">Please enter Security Information for the card ending in 
            <span> {this.props.cidposts.loginresponse.last4AcctNbr ? this.props.cidposts.loginresponse.last4AcctNbr : ( typeof this.props.cidposts.selectedCarddigits == "object" ? "xxxx" : this.props.cidposts.selectedCarddigits)}</span>.</div>
                
                <div className="security-code-num"><img src={securitycodenumbers} alt="Security Code Number"/></div>
                <div className="Enter-the-last-3-dig">Enter the last 3 digits of the security code on the back of your Discover card</div>
                <div class="security-code user-input-wrp">
                  <input type="text" className={(validation.securityCode.message === "" && this.state.errMessageCVV==="") ? "inputText" : "security-code-err"}   ref={(ip) => this.myInp = ip}  onBlur={this.handleOnBlur} value={this.state.securityCode} name="securityCode" aria-required="true"  id="no-paste-cvv" onChange={this.handleInputChange} required/>
                  <span class="floating-label">Security Code</span>
                  <img hidden={(validation.securityCode.message === "" &&  this.state.errMessageCVV==="") ? true : false} src={alert} alt="Error"/>
                  <div className="security-code-err-msg">{validation.securityCode.message !== "" ? validation.securityCode.message : ""}{(validation.securityCode.message === "") ? this.state.errMessageCVV : ''}</div>
                </div>
                <div className="security-code-num">
                   <img src={discoveritEmvbackCopy} alt="Discover IT card"/><span></span>
                </div>
                <div className="Enter-the-expiration">Enter the expiration date on your Discover card</div>
                <div className="security-code user-input-wrp">
                  <input type="text"
                      className={(validation.expiryDate.message === "" &&  this.state.errMsg==="") ? "inputText" : "security-code-err"}
                      value={this.state.expiryDate} name="expiryDate"
                      onChange={this.handleInputChange} 
                      ref={(ip2) => this.myInp2 = ip2} 
                      id="no-paste"
                      aria-required="true" 
                      onBlur={this.handleOnBlur} required />
                  <span class="floating-label">Expiration Date</span>
                   
                  <img hidden={(validation.expiryDate.message === "" &&  this.state.errMsg==="") ? true : false} src={alert} alt="Error" />
                  <div className="security-code-err-msg">{validation.expiryDate.message !== "" ? validation.expiryDate.message : ""}{validation.expiryDate.message === "" ? this.state.errMsg : ''}</div>
                </div>
                <div className="cid-continue-btn">
                <button onClick={this.handleFormSubmit} >Continue</button>
                </div>
                <div className="no-contact-cancel" ><button class="changebtnproperty" onClick={this.handleEvtCancel}>Cancel</button></div>
               
              
         <Modal show={this.state.show} handleClose={this.hideModal} >
            
            
                <div className=""> 
                
                  <div className="modal-header">Are you sure you want to cancel?</div>
                  <div  className="modal-txt"><div>Cancelling will log you out of your account. Please call us at </div><div><span>1-800-347-2655 </span> if you’re having trouble.</div></div>
                  <div className="modal-btn" onClick={this.handleEvtCancel}>Yes, cancel</div>
                 
                </div>
         </Modal>
          </div>
          </div>
        
    );
            }
  }
}

const mapStateToProps = (state) => {
  return {
    cidposts: state
  }
}

export default connect(mapStateToProps)(NoContactChannel);
